import React from 'react'
import "./ImageAdd.css"
import CloseIcon from '@mui/icons-material/Close';
import { BiSolidImageAdd } from "react-icons/bi";

export default function ImageAdd({ productImageHandler, productData, removeImageHandler, imageIndex }) {
    const imagesList = Array.isArray(productData?.image)
        ? productData.image.filter(Boolean)
        : (typeof productData?.image === 'string' ? productData.image.split(',').map(s => s.trim()).filter(Boolean) : []);

    return (
        <div className='w-100 d-flex flex-wrap align-items-center' style={{ gap: '16px' }}>
            {imagesList.length > 0 ? (
                <div className='d-flex p-1' style={{ gap: '12px', flexWrap: "wrap" }}>
                    {imagesList.map((img, index) => (
                        <div key={index} className='p-1 border rounded shadow-sm' style={{ boxSizing: "border-box", width: "100px", height: "100px", position: "relative", backgroundColor: "#ffffff" }}>
                            <CloseIcon style={{ position: "absolute", top: "4px", right: "4px", cursor: "pointer", fontSize: '14px', backgroundColor: "rgba(15, 23, 42, 0.75)", color: "#ffffff", borderRadius: "50%", padding: "2px", zIndex: 5 }} onClick={() => removeImageHandler(index, imageIndex)} />
                            <div className='w-100 h-100 d-flex align-items-center justify-content-center'>
                                <img src={img} alt={`uploaded-${index}`} className='w-100 h-100' style={{ objectFit: "cover", borderRadius: "6px" }} />
                            </div>
                        </div>
                    ))}
                </div>
            ) : null}

            {imagesList.length === 0 && (
                <div className="file-input-container">
                    <input type="file" id="image" accept="image/*" name="image" className='input_file' onChange={(e) => productImageHandler(e, imageIndex)} />
                    <label htmlFor="image" className='d-flex flex-column align-items-center justify-content-center border rounded' style={{ width: "100px", height: "100px", cursor: "pointer", backgroundColor: "#F8FAFC" }}>
                        <div>
                            <BiSolidImageAdd size={42} style={{ color: "#F97316" }} />
                        </div>
                        <div>
                            <span style={{ fontSize: "12px", fontWeight: 600, color: "#475569" }}>add images</span>
                        </div>
                    </label>
                </div>
            )}
        </div>
    )
}
